(function () {
  function initStatement(section) {
    var text = section.querySelector('.st-text');
    if (!text) return;

    text.querySelectorAll('.st-word-inner').forEach(function (el, i) {
      el.style.transitionDelay = (i * 0.045) + 's';
    });

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });

    observer.observe(text);
  }

  document.querySelectorAll('[data-statement-section]').forEach(initStatement);
})();
